import apiClient from "../utils/axiosInterceptor";


export const getApiForSalesRepAIData = async (payload: any) => {
    try {
        const response = await apiClient.post(`/fapp-ai-api/api/AISearchHandler`, payload);
        return response;

    } catch (error: any) {
        console.error('Error fetching:', error);
        return error.response?.status || 500;
    }
}

export const getSalesRepClassificationListAPI = async () => {
    try {
        const response = await apiClient.get(`/fapp-core-api/api/SalesRepClassification`);
        return response;

    } catch (error: any) {
        console.error('Error fetching:', error);
        return error.response?.status || 500;
    }
}